import React from 'react';
import { 
  Box, 
  Container, 
  Typography, 
  Switch, 
  FormControlLabel, 
  Slider,
  Paper,
  IconButton,
  Divider
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

function SettingsPage({ onBack, settings, onSettingsChange }) {
  const handleGlobalTimerEnabledChange = (event) => {
    onSettingsChange({
      ...settings,
      globalTimerEnabled: event.target.checked
    });
  };

  const handleGlobalTimerValueChange = (event, newValue) => {
    onSettingsChange({
      ...settings,
      globalTimerValue: newValue
    });
  };

  const handleLocalTimerEnabledChange = (event) => {
    onSettingsChange({
      ...settings,
      localTimerEnabled: event.target.checked
    });
  };

  const handleLocalTimerValueChange = (event, newValue) => {
    onSettingsChange({
      ...settings,
      localTimerValue: newValue
    });
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ pt: 4, pb: 6 }}>
        {/* Header with Back Button */}
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 4 }}>
          <IconButton 
            onClick={onBack}
            sx={{ mr: 2 }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h4">Settings</Typography>
        </Box>

        {/* Settings Content */}
        <Paper sx={{ p: 3 }}>
          {/* Global Timer Settings */}
          <Typography variant="h6" gutterBottom>Session Timer Settings</Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            Controls how long a test session lasts. During this time, try to get the highest score possible!
          </Typography>
          
          <Box sx={{ mb: 3 }}>
            <FormControlLabel
              control={
                <Switch
                  checked={settings.globalTimerEnabled}
                  onChange={handleGlobalTimerEnabledChange}
                />
              }
              label="Enable Session Timer"
            />
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography id="global-timer-value-slider" gutterBottom>
              Session Duration (seconds)
            </Typography>
            <Slider
              value={settings.globalTimerValue}
              onChange={handleGlobalTimerValueChange}
              disabled={!settings.globalTimerEnabled}
              aria-labelledby="global-timer-value-slider"
              valueLabelDisplay="auto"
              step={30}
              marks
              min={60}
              max={600}
            />
          </Box>

          <Divider sx={{ my: 3 }} />

          {/* Local Timer Settings */}
          <Typography variant="h6" gutterBottom>Question Timer Settings</Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            Sets the maximum time allowed to answer each question.
          </Typography>
          
          <Box sx={{ mb: 3 }}>
            <FormControlLabel
              control={
                <Switch
                  checked={settings.localTimerEnabled}
                  onChange={handleLocalTimerEnabledChange}
                />
              }
              label="Enable Question Timer"
            />
          </Box>

          <Box sx={{ mb: 2 }}>
            <Typography id="local-timer-value-slider" gutterBottom>
              Time per Question (seconds)
            </Typography>
            <Slider
              value={settings.localTimerValue}
              onChange={handleLocalTimerValueChange}
              disabled={!settings.localTimerEnabled}
              aria-labelledby="local-timer-value-slider"
              valueLabelDisplay="auto"
              step={5}
              marks
              min={10}
              max={120}
            />
          </Box>
        </Paper>
      </Box>
    </Container>
  );
}

export default SettingsPage; 